export enum ProductType {
  RSVP = 'Rsvp',
  EVENT = 'Event',
  GALLERY = 'Gallery',
  ADDITIONALPAGE = 'AdditionalPage',
  SAVEDATE = 'SaveDate',
  SENDER = 'Sender',
  GKS = 'GKS',
  BINGO = 'Bingo',
  VIDEOGALLERY = 'VideoGallery',
  PHYSICALMATERIAL = 'PhysicalMaterial',
  UNKNOW = 'Unknow',
}
